var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 116,
    viewBox: "0 0 1440 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86932 21.5586C87.8767 71.2416 113.879 -0.713156 309.897 21.5586C505.914 43.8303 477.912 67.8153 653.928 21.5586C829.944 -24.6982 1049.96 21.5586 1049.96 21.5586H1446V96.9398H1179.98C1179.98 96.9398 1049.96 96.9398 913.952 96.9398C777.939 96.9398 811.942 79.8077 681.93 96.9398C551.918 114.072 565.92 129.491 381.903 96.9398C197.887 64.3888 57.874 72.9547 5.86932 96.9398C-46.1354 120.925 -76.1381 -28.1245 5.86932 21.5586Z",
    fill: "url(#paint0_linear_703_2815)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 46.2953C1369.82 46.2953 1299.65 46.2953 1229.47 46.2953C1199.91 46.2953 1171.14 43.1485 1141.67 42.3347C1118.27 41.6884 1094.08 34.5582 1071.5 30.8929C1043.89 26.4131 1011.37 28.4726 983.014 28.4726C920.841 28.4726 855.862 26.8639 794.524 32.8732C759.309 36.3232 729.348 44.2124 695.533 50.256C675.641 53.811 654.228 61.5153 636.206 67.9687C626.966 71.2775 614.845 76 604 76",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 72C1414.13 72 1381.73 75.2934 1355.85 71.8889C1314.94 66.5079 1273.53 66 1231.15 66C1211.98 66 1194.38 70 1174.64 70C1150.53 70 1126.42 70 1102.31 70C1064.14 70 1027.11 72.6371 989.439 74C962.832 74.9626 937.118 72.5302 910.813 70.4444C883.641 68.2899 855.11 70 827.734 70C803.679 70 778.891 68.6673 754.944 70.1111C747.194 70.5784 721.029 71.6199 716.399 76C709.707 82.3322 692.113 79.7606 682.308 80.4444C665.744 81.5996 649.486 82 632.86 82C613.416 82 594.235 84 574.658 84C553.503 84 534.203 90 514 90",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M580 86C589.951 81.6535 603.972 71.9982 614.915 70.1074C623.204 68.6749 629.906 64.956 637.885 63.8837C645.051 62.9206 650.132 56.0351 657.731 53.9924C663.634 52.4056 676.689 49.9022 679.415 46.8797C684.775 40.9356 706.061 34.5339 715.799 31.0982C738.107 23.2282 769.82 19.8692 794.632 15.0944C812.364 11.6822 830.824 16.2641 847.923 11.0934C855.66 8.75389 864.696 11.0864 872.547 8.87069C880.315 6.67826 885.664 4.60966 894.231 3.86951C952.777 -1.18886 1015.72 1.98017 1075.42 1.98017C1150.57 1.98017 1232.06 -0.0474607 1303.65 15.5389C1313.11 17.5994 1317.27 21.9849 1328.27 21.9849C1339.53 21.9849 1350.83 22.1793 1362.09 21.9849C1388.27 21.5325 1413.79 13.983 1440 13.983",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-10 37.9999C18.4134 47.5468 42.3885 61.9999 72 61.9999C80.4565 61.9999 88.4585 57.4289 96.8889 55.5555C107.107 53.2848 117.54 53.9999 128 53.9999C154.949 53.9999 178.602 56.7798 203 45.111C221.569 36.23 238.157 35.8742 258.889 34.4444C269.318 33.7251 279.859 33.2376 290 35.5555C310.387 40.2153 334.611 39.2576 352.889 50.8888C360.457 55.705 378.818 51.9999 387.111 51.9999C395.686 51.9999 402.102 52.1879 410 54.4444C421.85 57.83 432.939 62.7778 445.111 65.9999C461.183 70.2543 475.538 69.9999 492.667 69.9999C498.926 69.9999 506.834 75.3581 512.778 77.9999C515.163 79.0598 520.364 81.891 522.444 83.5555C524.703 85.3622 531.045 84.5223 534 85.9999",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-6 70.0001C4.32129 70.0001 32.3881 65.4852 40 75.0001C41.3818 76.7274 57.0532 77.8364 60 78.0001C67.6549 78.4254 75.4442 78.0001 83.1111 78.0001C90.4444 78.0001 97.7778 78.0001 105.111 78.0001C113.066 78.0001 118.646 74.4087 126 74.0001C139.596 73.2448 152.265 70.0001 166.444 70.0001C181.776 70.0001 197.114 69.862 212.444 70.0001C236.43 70.2162 258.657 82.0001 282.111 82.0001C287.815 82.0001 292.138 82.3055 297.556 83.5557C333.35 91.8159 371.633 88.3767 407.778 96.6668C427.961 101.296 451.829 98.222 472.667 99.889C484.473 100.834 495.471 102 507.889 102C518.18 102 532.435 104.373 542 100C546.345 98.0138 550.353 98.0001 555 98.0001C560.599 98.0001 564.569 93.33 569.889 92.0001C578.119 89.9427 585.358 86.0001 594 86.0001",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_703_2815",
    x1: -45,
    y1: 58.5,
    x2: 1446,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235306,
    stopColor: "#FFE493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495738,
    stopColor: "#FFDD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704084,
    stopColor: "#FFEAAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881178,
    stopColor: "#FDF0C8",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllus);
export default __webpack_public_path__ + "static/media/illus.1f3f0c469ddaef91c12ea21e776810f9.svg";
export { ForwardRef as ReactComponent };